export const pageSizeList = [
    { text: "每页10条", Info: 10 },
    { text: "每页20条", Info: 20 },
    { text: "每页30条", Info: 30 },
]
